import { Injectable, signal } from "@angular/core";

/**
 * Centralized holder for the app's current fatal error state.
 * - Exposes a signal `error` that consumers (e.g., the error boundary) can subscribe to.
 * - `setError` coerces unknown inputs into an Error instance so downstream UI has a consistent shape.
 * - `clear` resets the state back to null, signaling recovery.
 */
@Injectable({ providedIn: "root" })
export class GlobalErrorService {
  readonly error = signal<Error | null>(null);

  setError(error: unknown): void {
    if (error instanceof Error) {
      this.error.set(error);
    } else {
      this.error.set(new Error(String(error)));
    }
  }

  clear(): void {
    this.error.set(null);
  }
}
